export default __webpack_public_path__ + "static/built-to-last.hevc_1-7599c1e09ac0a798d162e5d27f2de610.mp4";